<form [formGroup]="form">
  <div [hidden]="!formS.isPhoneFieldValid">
    <div class="text-center italic mb-36px mt-8px md:mt-8px">
      <div class="text-secondary">
        Thank you <span class="capitalize">{{ formS.userName }}</span> for
        providing your personal details
      </div>
      <div
        *ngIf="!formS.isPhoneConfirmed && (codeExpireAt$ | async)"
        class="mt-16px"
      >
        A One-Time-Passcode has been sent to your mobile number
        <span class="text-secondary"> {{ formS.phone }}</span
        >. Please provide that below to proceed with the registration
      </div>
    </div>

    <ib-mat-form-field-wrap>
      <ib-code-input-wrap
        #codeInput
        class="-mx-3px"
        [parentForm]="form"
        [phone]="formS.phone"
        [sendCodeLoading]="sendCodeLoading$ | async"
        [phoneCountry]="formS.phoneCountry"
        [phoneId]="formS.phoneId"
        [isPhoneConfirmed]="formS.isPhoneConfirmed"
        [formCtrl]="formS.phoneConfirmedFormCtrl"
        [abstractFormCtrl]="formS.phoneConfirmedAbstractFormCtrl"
        (resendCode)="resendCode()"
        [codeExpireAt]="codeExpireAt$ | async"
        (handleExpireWithUnconfirmedCode)="handleExpireWithUnconfirmedCode()"
        (phoneConfirmed)="phoneConfirmed($event)"
      >
      </ib-code-input-wrap>
    </ib-mat-form-field-wrap>
  </div>

  <div
    *ngIf="!formS.isPhoneFieldValid"
    class="text-center italic mb-36px mt-8px md:mt-8px"
  >
    <div class="text-secondary">
      Thank you <span class="capitalize">{{ formS.userName }}</span> for
      providing your personal details
    </div>
    <div
      class="text-error mt-16px flex justify-center items-center text-center text-14px"
    >
      <i class="material-icons text-14px mr-8px text-px text-error!"
        >warning_amber</i
      >
      <span>Please add Your phone number in the previous step </span>
    </div>
  </div>

  <hr class="my-36px" />

  <div class="text-center italic mb-36px mt-36px md:mt-16px">
    <ng-container *ngIf="!formS.isCompanyAccount">{{
      config.description | transloco
    }}</ng-container>

    <ng-container *ngIf="formS.isCompanyAccount">{{
      config.descriptionCompany | transloco
    }}</ng-container>
  </div>

  <ib-mat-form-field-wrap
    [formCtrlName]="SIGN_UP_FIELDS.STREET_AND_NUMBER"
    [formCtrl]="form.get(SIGN_UP_FIELDS.STREET_AND_NUMBER)"
    [showClearBtn]="true"
  >
    <mat-form-field>
      <mat-label>Street Address</mat-label>
      <input
        matInput
        #streetInput
        formControlName="{{ SIGN_UP_FIELDS.STREET_AND_NUMBER }}"
        placeholder="Street and number"
        required
        (keydown.enter)="submitFromInput($event)"
      />
    </mat-form-field>
  </ib-mat-form-field-wrap>

  <ib-mat-form-field-wrap
    [formCtrlName]="SIGN_UP_FIELDS.CITY"
    [formCtrl]="form.get(SIGN_UP_FIELDS.CITY)"
    [showClearBtn]="true"
  >
    <mat-form-field>
      <mat-label>City/Town</mat-label>
      <input
        matInput
        formControlName="{{ SIGN_UP_FIELDS.CITY }}"
        (keydown.enter)="submitFromInput($event)"
        required
      />
    </mat-form-field>
  </ib-mat-form-field-wrap>

  <ib-mat-form-field-wrap
    class="sm:w-1/2"
    [formCtrlName]="SIGN_UP_FIELDS.POSTAL_ZIP_CODE"
    [formCtrl]="form.get(SIGN_UP_FIELDS.POSTAL_ZIP_CODE)"
    [showClearBtn]="true"
  >
    <mat-form-field>
      <mat-label>Postal/Zip Code</mat-label>
      <input
        matInput
        (keydown.enter)="submitFromInput($event)"
        formControlName="{{ SIGN_UP_FIELDS.POSTAL_ZIP_CODE }}"
        required
      />
    </mat-form-field>
  </ib-mat-form-field-wrap>

  <ib-mat-form-field-wrap
    [formCtrlName]="SIGN_UP_FIELDS.COUNTRY_CODE"
    [formCtrl]="countryCodeCtrl"
    [showClearBtn]="true"
  >
    <ib-country
      [formCtrl]="countryCodeCtrl"
      [isRequired]="true"
      class="block"
    ></ib-country>
  </ib-mat-form-field-wrap>
</form>
